import { render } from "./ClusterEditForm.vue?vue&type=template&id=7e2807d4"
import script from "./ClusterEditForm.vue?vue&type=script&lang=js"
export * from "./ClusterEditForm.vue?vue&type=script&lang=js"
script.render = render

export default script